(() => {
  if (window.__yoraDirectCheckoutEnabled) return;
  window.__yoraDirectCheckoutEnabled = true;

  const script = document.currentScript;
  const cartAddUrl = script?.dataset.cartAddUrl || '/cart/add.js';
  const checkoutUrl = script?.dataset.checkoutUrl || '/checkout';

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.directCheckoutIgnore === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    buttons.forEach((button) => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(form);
      formData.delete('return_to');
      formData.delete('sections');
      formData.delete('sections_url');

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added to the cart.');
      window.location.assign(checkoutUrl);
    } catch (error) {
      form.removeAttribute('aria-busy');
      buttons.forEach((button) => { button.disabled = false; });
      if (submitter) submitter.focus();
      window.alert(error.message || 'This item could not be added to the cart.');
    }
  }, true);
})();
